/**
 * English number words we resolve to digits before extraction. Capped at five
 * because higher counts are essentially never spelled out in real-estate
 * search queries.
 */
const NUMBER_WORDS: Record<string, number> = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
};

const NUMBER_WORD_PATTERN = new RegExp(`\\b(${Object.keys(NUMBER_WORDS).join('|')})\\b`, 'gi');

/**
 * Convert English number words ("three") to digits ("3") and normalize
 * digit-letter hyphens ("3-bedroom" → "3 bedroom") so extractors share one
 * normalized string and span indices stay consistent.
 */
export function normalizeQuery(query: string): string {
  let result = query.replace(NUMBER_WORD_PATTERN, match => String(NUMBER_WORDS[match.toLowerCase()]));
  result = result.replace(/(\d)-(?=[a-z])/gi, '$1 ');
  return result;
}
